import { Component, OnInit } from "@angular/core";
import { BsModalRef } from "ngx-bootstrap/modal";

import { saveAs } from "file-saver";
import { LanguageTranslateService } from "src/app/_services/language-translate.service";

@Component({
    selector: "app-download-barcode",
    templateUrl: "./download-barcode.component.html",
    styleUrls: ["./download-barcode.component.scss"],
    standalone: false
})
export class DownloadBarcodeComponent implements OnInit {
  data: any;
  barCodeType: any;
  translate: any;
  valueQR: any;
  valueQRToDisplay: any;
  copyText: any;

  constructor(public modalRef: BsModalRef,
    private languageTranslateService: LanguageTranslateService
  ) {
    this.languageTranslateService.menuSrc$.subscribe(data => {
      if(Object.keys(data).length != 0){ this.translate = data}
    })
  }

  ngOnInit() {
    console.log("data in download barcode", this.data);
    this.init();
  }

  /******************************************** Init ******************************************/
  private init() {
    console.log("data in download barcode init", this.data);
    
    if (this.data &&  this.data?.page === 'Asset' ) {

      // added on 6oct 2026 ----
       if ((this.data.assetData && this.data.assetData?.qrCodeType) || this.data.assetData?.barCodeType ) {
        this.barCodeType =
          this.data.assetData?.qrCodeType ?? this.data.assetData?.barCodeType;
      } else {
        this.barCodeType = localStorage.getItem("qrCodeType");
      }
      // End on 6oct 2026 ----

     
      //////////this.barCodeType = this.data.assetData.qrCodeType ?? this.data.assetData.barCodeType; // Prioritize QR code type if available, otherwise use barcode type
    
      /// this.valueQR = this.data?.assetData?.encryptedTenantId; // Assuming you want to use encryptedTenantId for QR code generation
     // this.valueQRToDisplay = this.data.assetData.serialNo; // Display serial number as the label for the QR code
     // this.copyText = 'Copy Link';


       if(this.data?.assetData?.encryptedTenantId){
         this.valueQR = this.data?.assetData?.encryptedTenantId // Assuming you want to use encryptedTenantId for QR code generation
         this.copyText = 'Copy Link';
      }else{
        this.valueQR = this.data?.assetData?.serialNo // Assuming you want to use serial number for QR code generation
        this.copyText = 'Copy Code';
      }
       this.valueQRToDisplay = this.data.assetData.serialNo; // Display serial number as the label for the QR code
     


   
    }else if (this.data && this.data?.page === 'Site') {
      if(this.data?.siteData?.encryptedTenantId){
         this.valueQR = this.data?.siteData?.encryptedTenantId // Assuming you want to use siteCode for QR code generation
         this.copyText = 'Copy Link';
      }else{
        this.valueQR = this.data?.siteData?.siteCode // Assuming you want to use siteCode for QR code generation
        this.copyText = 'Copy Code';
      }
       this.valueQRToDisplay = this.data.siteData.siteCode; // Display site code as the label for the QR code
     
    } 
    // else {
    //   this.barCodeType = localStorage.getItem("qrCodeType");
    //    this.valueQR =  this.data?.assetData?.serialNo; // Assuming you want to use serial number for QR code generation if no specific type is provided
    //    this.valueQRToDisplay = this.data.assetData.serialNo; // Display serial number as the label for the QR code
    //    this.copyText = 'Copy Code';
    // }
  }

  /******************************************** Download QR ******************************************/
  public downloadQRCode() {
    let canvas = document.querySelector("canvas")!;
    canvas.toBlob((blob: any) => {
      saveAs(blob, this.valueQRToDisplay + ".png");
    });
  }


  /******************************************** Copy Serial No. ******************************************/
  copySerialNo(val: string) {
    const selBox = document.createElement("textarea");
    selBox.style.position = "fixed";
    selBox.style.left = "0";
    selBox.style.top = "0";
    selBox.style.opacity = "0";
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand("copy");
    document.body.removeChild(selBox);
  }
}
